import { i18n } from 'i18n';

export interface CylinderBreakingTestUpdateParams extends Record<string, string | undefined> {
  pourId: string;
  breakingScheduleId: string;
  breakingTestId: string;
}

export const POUR_PARAM_IDENTIFIER = ':pourId';
export const BREAKING_SCHEDULE_PARAM_IDENTIFIER = ':breakingScheduleId';
export const BREAKING_TEST_PARAM_IDENTIFIER = ':breakingTestId';

// eslint-disable-next-line max-len
export const ROUTE_PATH = `/qaqc/${POUR_PARAM_IDENTIFIER}/breaking-schedules/${BREAKING_SCHEDULE_PARAM_IDENTIFIER}/breaking-test/${BREAKING_TEST_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('Update Cylinder Breaking Test');
